import InfoCircle from 'assets/icons/InfoCircle';
import Tooltip from 'components/common/Tooltip';
import FloatingNumberInput from 'components/ui/FloatingNumberInput';
import { BREAK_FREQUENCY_MINUTES } from 'constants/general';
import { ATTRIB } from 'constants/test';
import { useMemo } from 'react';
import { t } from 'services/i18n.service';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { timingSelector } from 'store/reducer/setting/selectors';
import { changeBreakingInterval } from 'store/reducer/setting/slice';
import { createHtml } from 'utils/helpers';
import { breakFrequencyValidation } from 'utils/validators';

const BreakFrequency = () => {
  const dispatch = useAppDispatch();
  const { break_after_minutes } = useAppSelectorShallow(timingSelector);

  const { message, isValid } = useMemo(
    () => breakFrequencyValidation(break_after_minutes),
    [break_after_minutes]
  );

  const handleBreakFrequencyBlur = () => {
    if (
      break_after_minutes === undefined ||
      break_after_minutes === null ||
      break_after_minutes < BREAK_FREQUENCY_MINUTES.MIN
    ) {
      dispatch(changeBreakingInterval(BREAK_FREQUENCY_MINUTES.MIN));
    }
  };

  return (
    <div
      className='flex items-center gap-0.5'
      data-testid={ATTRIB.DATA_TESTID.BREAK_FREQUENCY_WRAPPER}>
      <FloatingNumberInput
        label={t('settings_page.interval')}
        value={break_after_minutes}
        onChangeHandler={(value) => {
          if (value !== break_after_minutes) {
            dispatch(changeBreakingInterval(value));
          }
        }}
        onBlur={handleBreakFrequencyBlur}
        type='number'
        min={BREAK_FREQUENCY_MINUTES.MIN}
        containerClassName='~w-28/40'
        inputClassName='text-center dark:text-secondary-dark-900 dark:border dark:border-secondary-dark-500'
        labelClassName='dark:text-secondary-dark-900 rounded-t-md'
        error={!isValid ? message : undefined}
        placeholder={t('settings_page.interval')}
        size='small'
        variant='filled'
      />
      <Tooltip
        icon={<InfoCircle styles='~w-4/5 h-auto' />}
        element={<span>{createHtml(t('explanation_break_interval'))}</span>}
      />
    </div>
  );
};

export default BreakFrequency;
